import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import Chip from "./Chip";

type FilterChipProps = {
  height?: number | string;
  isActive: boolean;
  name: string;
  noOfActiveFilters: number;
  onClick: () => void;
};

export const FilterChip = ({ height = "4.2rem", isActive, name, noOfActiveFilters, onClick }: FilterChipProps) => {
  const { t } = useTranslation();
  return (
    <Chip className="relative !h-[4.2rem]" height={height} isOn={isActive} onClick={onClick}>
      <span>{name}</span>
      {noOfActiveFilters > 0 && (
        <Stack className="absolute bottom-[2px] left-2 gap-1 text-lds-foreground-muted font-ds-number-regular-xs">
          <div className="h-[6px] w-[6px] rounded-full bg-lds-purpose-status-negative-subtle" />
          <span>{noOfActiveFilters}</span>
          <span>{t("Portfolio.filters.filter")}</span>
        </Stack>
      )}
    </Chip>
  );
};
